import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ReportAnalysisType } from 'app/core/enums/common.enum';
import { AnalysisReportsEndpoints } from 'app/core/enums/endpoints';
import {
    CostAnalysisParams,
    FinalReportParams,
} from 'app/core/interfaces/reports';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReportAnalysisAPIService {
    private _endpoints = AnalysisReportsEndpoints;
    private _http = inject(HttpClient);
    private apiUrl = environment.apiUrl;
    currentShowId: number = null;
    currentVenueId: number = null;
    currentPlaydateId: number = null;
    currentTurning: number = 0.85;

    finalReportParams: FinalReportParams = {
        turnInDue: 0,
        companyDeposit: 0,
        personalCommission: 0,
    };

    costAnalysisParams: CostAnalysisParams = {
        transferPer: 0,
        personalCommission: 0,
    };

    // Optional filters
    locationId: number = null;
    categoryId: number = null;
    subCategoryId: number = null;

    currentReportTitle: string = null;

    constructor() {}

    // ------------------------------------------------------------------------
    // @ Public Methods
    // ------------------------------------------------------------------------

    getQueryParams(reportType: ReportAnalysisType) {
        if (!reportType) {
            return;
        }

        const body = {
            playdate_id: this.currentPlaydateId,
        };

        switch (reportType) {
            case ReportAnalysisType.COST_ANALYSIS:
                body['transfer_per'] = this.costAnalysisParams.transferPer;
                body['personal_commission'] =
                    this.costAnalysisParams.personalCommission;

                if (this.categoryId) body['category_id'] = this.categoryId;
                if (this.subCategoryId)
                    body['subcategory_id'] = this.subCategoryId;
                break;

            case ReportAnalysisType.INV_ANALYSIS:
                body['turning'] = this.currentTurning;

                if (this.locationId) body['location_id'] = this.locationId;
                if (this.categoryId) body['category_id'] = this.categoryId;
                if (this.subCategoryId)
                    body['subcategory_id'] = this.subCategoryId;
                break;

            case ReportAnalysisType.FINAL_REPORT:
                body['turn_in_due'] = this.finalReportParams.turnInDue;
                body['company_deposit'] = this.finalReportParams.companyDeposit;
                body['personal_commission'] =
                    this.finalReportParams.personalCommission;
                break;
        }

        return body;
    }

    // ------------------------------------------------------------------------
    // @ Fetch Report
    // ------------------------------------------------------------------------

    /**
     * @description
     * Fetches the inventory sales analysis report data from the API.
     */
    getInventorySalesAnalysis(): Observable<any> {
        return this._http.post(
            `${this.apiUrl}/${this._endpoints.getInventorySalesAnalysis}`,
            this.getQueryParams(ReportAnalysisType.INV_ANALYSIS)
        );
    }

    /**
     * @description
     * Fetches the final report data from the API.
     */
    getFinalReport(): Observable<any> {
        return this._http.post(
            `${this.apiUrl}/${this._endpoints.getFinalReport}`,
            this.getQueryParams(ReportAnalysisType.FINAL_REPORT)
        );
    }

    /**
     * @description
     * Fetches the cost analysis report data from the API.
     */
    getCostAnalysisReport(): Observable<any> {
        return this._http.post(
            `${this.apiUrl}/${this._endpoints.getCostAnalyticsReport}`,
            this.getQueryParams(ReportAnalysisType.COST_ANALYSIS)
        );
    }
}
